const ENNotifications = {
	"Adicionar notificação": "Add notification",
	"Alterar notificação": "Change notification",
	"Administradores": "Administrators",
	"Data inicial inválida": "Invalid start date",
	"Data final inválida": "Invalid end date",
	"Deseja realmente excluir a notificação": "Do you really want to delete the notification",
	"Entendi": "I understood",
	"Erro ao adicionar notificação": "Error adding notification",
	"Erro ao alterar notificação": "Error changing notification",
	"Erro ao excluir notificação": "Error deleting notification",
	"Exclusão da notificação": "Exclusion of notification",
	"Exibir para": "Display to",
	"Informação": "Information",
	"Mensagem": "Message",
	"Mensagem é requerida": "Message is required",
	"Não Administradores": "No Administrators",
	"Notificações": "Notifications",
	"Notificação adicionada com sucesso": "Notification successfully added",
	"Notificação alterada com sucesso": "Notification changed successfully",
	"Notificação excluída com sucesso": "Notification successfully deleted",
	"Nova notificação": "New notification",
	"Pré-visualizar": "Preview",
	"Todos Usuários": "All Users"
};

export default ENNotifications;
